module.exports = __webpack_public_path__ + "img/送货车_transporter-2.15a796da.svg";